import React from 'react';
import { Weather } from '../types/weather';

interface Props {
  city: string;
  weather: Weather | null;
  loading: boolean;
  onRefresh: () => void;
  onRemove: () => void;
  onClick: () => void;
}

const WeatherCard: React.FC<Props> = ({ city, weather, loading, onRefresh, onRemove, onClick }) => (
  <div className="weather-card" onClick={onClick} style={{ border: '1px solid #ccc', borderRadius: 8, padding: 16,  cursor: 'pointer', maxWidth: 250 , height: "100%"}}>
    <h3>{city}</h3>
    {loading ? (
      <p>Loading...</p>
    ) : weather ? (
      <>
        <p>{weather.temp}°C, {weather.description}</p>
        <img src={`https://openweathermap.org/img/wn/${weather.icon}@2x.png`} alt={weather.description} />
        <p>Humidity: {weather.humidity}%</p>
        <p>Wind: {weather.wind} m/s </p>
      </>
    ) : (
      <p>No data</p>
    )}
    <button onClick={e => { e.stopPropagation(); onRefresh(); }}>update</button>
    <button onClick={e => { e.stopPropagation(); onRemove(); }}>delete</button>
  </div>
);

export default WeatherCard; 